import styled from "@emotion/styled";
import {Button} from "@mui/material";

export const ElementButton = styled(Button)(
    ({theme}) => ({
        color: "black",
        height: "40px",
        backgroundColor: "var(--color-yellow)",
        '&:hover': {
            backgroundColor: "var(--color-yellow-hover)",
        },
        marginRight: "15px"
    })
);